<template>
    <div class="d-flex">
        <b-button
            class="mr-1"
            variant="default"
            v-if="downloadLink"
            :href="downloadLink"
        >
            <font-awesome-icon :icon="['fas', 'download']" />
        </b-button>
        <b-button variant="default" @click="$bvModal.show(modalId)">
            <font-awesome-icon :icon="['fas', 'eye']" />
        </b-button>
        <modal
            body-class="communication-iframe-modal"
            :id="modalId"
            title="Message Content"
            size="lg"
            ok-only
        >
            <iframe class="iframe-content w-100 h-100" :src="iframeLink" />
        </modal>
    </div>
</template>

<script>
import Modal from '../../../generic/modal/modal.vue';
export default {
    components: {
        Modal,
    },
    inject: ['userId'],
    computed: {
        modalId() {
            return 'show-message-modal' + this.params.data.id;
        },
        downloadLink() {
            return this.params && this.params.data.download_link;
        },
        iframeLink() {
            return (
                `/app/admin/user/account-communication/${this.userId}/get-email-text` +
                '/?email_pk=' +
                this.params.data.id
            );
        },
    },
};
</script>


<style scoped lang="scss">
.iframe-content {
    border: none;
}
</style>
<style>
.communication-iframe-modal {
    min-height: 400px;
}
</style>